import { orgQueryKeys } from '@/config/queryKeys';
import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess } from '@/helpers';
import { getSelectedOrg, hasAnyOrgRole } from '@/helpers/roles';
import { getOrganization } from '@/services/organizations';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/organizations/$orgId')({
  beforeLoad: ({ context, location }) => {
    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;
    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: ({ context, params: { orgId } }) => {
    // beforeLoad returns without throwing while auth is still PENDING, so the loader can still
    // run in that window — gate the actual fetch here too (issue #396, same as its siblings).
    const selectedOrganization = getSelectedOrg();
    if (
      context.authentication.status !== 'AUTHENTICATED' ||
      !selectedOrganization?.id ||
      !hasAnyOrgRole(context.authentication.user?.assumed_roles, selectedOrganization.id, adminRoles)
    ) {
      return undefined;
    }

    return context.queryClient.ensureQueryData({
      queryKey: orgQueryKeys.detail(orgId),
      queryFn: () => getOrganization(orgId),
    });
  },
});
